export default "__VITE_ASSET__CvlhSa6O__"